import React from "react";

import "./StandbyScreen.scss";

const StandbyScreen = ({ standbyImage, onTouch }) => {
  return (
    <div className="StandbyScreen" onClick={onTouch}>
      <img src={standbyImage} alt="Standby" className="StandbyImage" />
    </div>
  );
};

export default StandbyScreen;
